const uiManagement = {
    uiList: [],
    loadingUIs: true
};

export default uiManagement;
